const SeaPortCustoms = () => {
  return (
    <div>
    
    <div className="flex flex-col justify-center  gap-1 max-w-[50rem] mx-auto pl-[2rem] pt-[1rem] pr-[2rem]">
      <h1 className="text-[20px] font-bold">Seaport Customs</h1>
      <p>
        Pakistan’s seaports handle more than 80% of country’s imports and exports. Seaports’ scales of tolls, 
        rates, dues, and charges provide the basis for not only the tariffs but also the customs regulations. 
        TCS can help you fulfil the relevant conditions and comply with the customs procedures to get the 
        imports, exports and individual shipments cleared from the seaports in time.
      </p>

     
    </div>
  </div>
  );
};
  
export default SeaPortCustoms;
  